import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "absolute inset-0 p-6 sm:p-8 flex items-end sm:items-center sm:justify-center" }

import { computed, ref, toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    noPadding: { type: Boolean },
    size: null,
    close: null
  },
  setup(__props: any) {

const props = __props as {
  noPadding?: boolean,
  size?: 'lg',
  close:() => void,
}



const { noPadding, size, close } = toRefs(props);
const panel = ref(null);

const modalSize = computed(() => {
  if (size?.value === 'lg') return 'sm:max-w-2xl';
  return 'sm:max-w-md';
});

return (_ctx: any,_cache: any) => {
  const _component_base_overlay = _resolveComponent("base-overlay")!

  return (_openBlock(), _createBlock(_component_base_overlay, {
    panel: panel.value,
    close: _unref(close)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["bg-white/90 backdrop-blur-lg border border-blue-50 rounded-xl shadow-xl shadow-blue-700/30 w-full max-h-full overflow-y-auto", [_unref(modalSize), _unref(noPadding) ? '' : 'p-8']]),
          ref_key: "panel",
          ref: panel,
          role: "dialog",
          "aria-modal": "true"
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ])
    ]),
    _: 3
  }, 8, ["panel", "close"]))
}
}

})